<template>
<div class="chapter">
<div class="inner_page">
<div id="d08649ec90568-d1e360"><span id="pagev">
<p class="prelims-epigraph-first-space-after">‘My convictions on this subject have been confirmed. That those tribes cannot exist surrounded by our settlements and in continual contact with our citizens is certain. They have neither the intelligence, the industry, the moral habits, nor the desire of any improvement which are essential to any favorable change in their condition. Established in the midst of another and a superior, and without appreciating the causes of their inferiority or seeking to control them, they must necessarily yield to the force of circumstances and ere long disappear.’</p>
<p class="prelims-epigraph-source-space-after"><em class="italic ">President Andrew Jackson, addressing Congress in 1833.</em></p>
<p class="prelims-epigraph-space-after">The new Bugs Without Borders Survey conducted by the National Pest Management Association (NPMA) and the University of Kentucky found that bed bug infestations in the United States continue at a high rate. The survey of US pest management professionals found that 99.6 percent of respondents encountered bed bug infestations in the past year and that infestations have increased in the majority of locations in which pest professionals typically treat for bed bugs.</p>
<p class="prelims-epigraph-source"><em class="italic ">Pestworld.org, 2013</em></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106588_epub_epi.vue?4b2a5c6a